import { createVNode as n, mergeProps as T } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/TxtTwoTone.js";
import s from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return n(s, T(e, {
    icon: m
  }), null);
};
o.displayName = "TxtTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
